// Home js
import React from 'react';
import './Home.css'
import HomeTop from './HomeTop';

const Home = () => {
    
    return (
        <div className="home">
            <div>
               <HomeTop/>                         
            </div>
        </div>
    );
};

export default Home;